









































import {
	computed,
	defineComponent,
	onMounted,
	ref,
	Ref,
	watchEffect,
} from '@vue/composition-api';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import { Content } from '@front-app/services/GroupsApi/DiscussionModel';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { getGroupContent } from '@front-app/services/GroupsApi/GroupsContentApi';
import { useHighlightsInput } from '@front-app/modules/group/highlights/hooks/useHighlightsInput';
import { SearchOption } from '@front-app/components/search/useSearch';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import SearchGroupFiles from '@front-app/components/inputs/SearchGroupFiles.vue';
import FormError from '@front-app/components/form/FormError.vue';
import { BUTTON_EDITOR_PROPS } from './buttonEditor';
import BaseButtonEditor from './BaseButtonEditor.vue';

export default defineComponent({
	components: {
		BaseButtonEditor,
		FormSection,
		FormLabel,
		SearchGroupFiles,
		FormError,
	},
	props: BUTTON_EDITOR_PROPS,
	setup(props, ctx) {
		const useInput = useHighlightsInput(ctx, computed(() => props.value));

		// Validation
		const validation = v({
			contentId: {
				value: computed(() => props.value.meta.contentId),
				rules: [required()],
			},
			contentSource: {
				value: computed(() => props.value.meta.contentSource),
				rules: [required()],
			},
		});
		onMounted(() => {
			validation.validate();
		});

		// File Search
		const selectedFile: Ref<undefined | Content> = ref(undefined);
		watchEffect(async () => {
			const newId = props.value.meta.contentId;
			if (newId && newId !== selectedFile.value?.id) {
				// Fetch the file and save
				selectedFile.value = await getGroupContent(props.group.id, newId);
			}
		});
		const handleFileSearchItemClicked = (content: SearchOption<Content>): void => {
			selectedFile.value = content.original;
			useInput.doMetaInput({ contentId: content.original.id, contentSource: content.original.source });
			validation.validate();
		};
		// END File Search

		return {
			validation,
			DropdownPosition,
			selectedFile,
			handleFileSearchItemClicked,
		};
	},
});
